<template lang="pug">
  center(v-if='loading')
    .d-flex
      .loading-spinner.cargando-spinner
        .dotOne
        .dotTwo
        .dotThree
        .dotFour
        .dotFive
        .dotSix
        .dotSeven
  .row(v-else)
    .col-12
      header.mb-4
        h1#tittle {{$route.name}}
    .col-lg-12.mb-3
      .row.d-flex.justify-content-end
        .col-lg-2.col-md-12(v-if="clientLogin === 'Aulatributaria'")
          router-link.btn#buttons(to="/add-users") Carga masiva Aula
        .col-lg-2.col-md-12(v-if="clientLogin === 'reunion-tributaria'")
          button.btn#buttons(@click="downloadResume") Resumen usuarios
        .col-lg-2.col-md-12
          router-link.btn#buttons(to="/add-user") Crear usuario
    .col-12
      .card
        .card-header
          .row
            .col-10
              b-form-input(@keyup.enter="search()" v-model="busqueda" placeholder="Buscar por nombre, apellido, rut o email" aria-label="Buscar usuario")
            .col-2
              b-button(
                block
                variant="outline-primary"
                @click="search()"
                class="d-flex align-items-center justify-content-center"
                aria-label="Buscar"
              ) Buscar
        .card-body
          b-table(striped hover ref="table" :items="formatedListUser" :fields="fields" stacked-md id="table-user")
            template(v-slot:head(Correo)="data")
              | E-mail
            template(v-slot:head(edit)="data")
            template(v-slot:cell(edit)="data")
              b-dropdown.btn.btn-dropdown_transparent.float-right(no-caret)
                template(v-slot:button-content)
                  font-awesome-icon.icon(icon="ellipsis-h")
                b-dropdown-item(@click="editUser(data.item)")
                  font-awesome-icon.icon.me-2(icon="pencil-alt")
                  | Editar
                b-dropdown-divider
                b-dropdown-item( @click="deleteUser(data.item)" )
                  font-awesome-icon.icon.me-2(icon="trash-alt")
                  | Eliminar
        .card-footer
          .row
            .col-8
              nav(aria-label="Page navigation" style="padding-left: 62%")
                ul.pagination
                  li.page-item
                    a.page-link(@click="functionFirstPage()") &laquo;
                  li.page-item
                    a.page-link(@click="functionPrevPage()") &lt;
                  li.page-item
                    a.page-link(style="color: #000000;") {{ this.currentPage }}
                  li.page-item
                    a.page-link(@click="functionNextPage()") &gt;
                  li.page-item
                    a.page-link(@click="functionLastPage()") &raquo;
            .col-4
              p(style="text-align: right; padding-top: 2%;") Total de usuarios: {{this.totalUsers}}
</template>

<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'
import { appisAmulenCore } from '../utils/axiosInstances'

export default {
  name: 'userList',
  data () {
    return {
      loading: false,
      perPage: 0,
      currentPage: 0,
      fields: [
        {
          key: 'name',
          label: 'Nombre'
        },
        {
          key: 'lastname',
          label: 'Apellidos'
        },
        {
          key: 'rut',
          label: 'Rut'
        },
        {
          key: 'email',
          label: 'Email'
        },
        'edit'
      ],
      allListUsers: [],
      formatedListUser: [],
      formatedListUserSearch: [],
      user: {},
      userDelete: '',
      totalUsers: 0,
      info: '',
      prevPage: 0,
      lastPage: 0,
      page: 1,
      options: [
        { value: 'name', text: 'Nombre' },
        { value: 'lastname', text: 'Apellido' },
        { value: 'rut', text: 'Rut' },
        { value: 'email', text: 'Correo' }
      ],
      selected: 'name',
      busqueda: '',
      clientLogin: localStorage.getItem('clientName')
    }
  },
  methods: {
    deleteUser (user) {
      this.userDelete = ''
      this.$bvModal.msgBoxConfirm('¿Está seguro que desea eliminar este usuario?', {
        title: 'Por favor confirme',
        size: 'md',
        buttonSize: 'md',
        okVariant: 'danger',
        cancelVariant: 'light',
        okTitle: 'Eliminar',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2 justify-content-between',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          appisAmulenCore({
            method: 'delete',
            url: '/user',
            data: {
              _id: user.id
            }
          }).then(response => {
            const index = this.formatedListUser.findIndex(userDelete => userDelete.id === user.id)
            if (~index) { // if userDelete exists in array
              this.formatedListUser.splice(index, 1) // delete user
            }
          })
        }
      })
    },
    async search () {
      this.loading = true
      // const seleccionado = this.$refs.selected.value
      this.currentPage = 0
      this.totalUsers = 0
      this.formatedListUser = []

      try {
        const query = `name=${this.busqueda}&lastname=${this.busqueda}&rut=${this.busqueda}&email=${this.busqueda}`
        const response = await appisAmulenCore.get(`/user?${query}`)

        // Obtener la lista de usuarios
        this.allListUsers = response.data.message.docs
        this.info = response.data.message

        // Formatear la lista de usuarios
        this.formatedListUser = this.allListUsers.map(user => ({
          rut: user.rut,
          name: user.name,
          lastname: user.lastname,
          email: user.email,
          id: user._id
        }))

        // Actualizar los detalles de la paginación
        this.totalUsers = this.info.totalDocs
        this.perPage = this.info.limit
        this.currentPage = this.info.page
        this.prevPage = this.info.prevPage
        this.lastPage = this.info.totalPages

        this.loading = false
      } catch (error) {
        this.$router.push('/login')
        this.loading = false
        throw error
      }
    },
    functionFirstPage () {
      if (this.page !== 1) {
        this.page = 1
        this.getUserList()
      }
    },
    functionLastPage () {
      if (this.page !== this.lastPage) {
        this.page = this.lastPage
        this.getUserList()
      }
    },
    functionNextPage () {
      if (this.page < this.lastPage) {
        this.page += 1
        this.getUserList()
      }
    },
    functionPrevPage () {
      if (this.page > 1) {
        this.page -= 1
        this.getUserList()
      }
    },
    async downloadResume () {
      const response = await appisAmulenCore.get('/user-csv', {
        responseType: 'blob'
      })

      if (response.headers['content-type'] === 'text/csv; charset=utf-8') {
        // Crear un enlace para la descarga
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv' }))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'resumen-usuarios.csv')
        document.body.appendChild(link)
        link.click()

        // Limpia el enlace y la URL
        link.remove()
        window.URL.revokeObjectURL(url)
      }
    },
    async getUserList () {
      this.loading = !false
      this.currentPage = 0
      this.totalUsers = 0
      this.formatedListUser = []
      try {
        const response = await appisAmulenCore.get(`/user?page=${this.page}`)
        this.allListUsers = response.data.message.docs
        this.info = response.data.message
        this.allListUsers.map(async user => {
          this.formatedListUser.push({
            rut: user.rut,
            name: user.name,
            lastname: user.lastname,
            email: user.email,
            id: user._id
          })
        })
        this.totalUsers = this.info.totalDocs
        this.perPage = this.info.limit
        this.currentPage = this.info.page
        this.prevPage = this.info.prevPage
        this.lastPage = this.info.totalPages
        this.loading = !true
      } catch (error) {
        this.$router.push('/login')
        throw error
      }
    },
    // Save id user to use in getDataUser
    async editUser (user) {
      const url = '/user?page='.concat(this.currentPage)
      const userData = await appisAmulenCore.get(url)
      const userTemp = userData.data.message.docs.find(
        x => x.id === user.id
      )
      if (!userTemp) {
        let query = ''
        if (this.busqueda) {
          query = `name=${this.busqueda}&lastname=${this.busqueda}&rut=${this.busqueda}&email=${this.busqueda}`
        }

        let userDataSearch = ''
        if (query) {
          userDataSearch = await appisAmulenCore.get(`/user?${query}`)
        }

        const userTempSearch = userDataSearch?.data?.message?.docs.find(x => x.id === user.id)

        if (userTempSearch) {
          this.$store.commit('EDIT_USER', { user: userTempSearch })
          this.$router.push('/edit-user/')
        }
      } else {
        this.$store.commit('EDIT_USER', { user: userTemp })
        this.$router.push('/edit-user/')
      }
    },
    // Save all data of the user
    async getDataUser () {
      const userData = await appisAmulenCore.get('/user')
      const user = userData.data.message.docs.find(
        x => x.id === this.$store.state.userTemp.id
      )
      this.$store.commit('EDIT_USER', { user: user })
    }
  },
  created () {
    this.$emit('update:layout', DefaultLayout)
  },
  mounted () {
    this.getUserList()
  }
}

</script>
<style lang="stylus">
  .d-flex
    display: flex
  .loading-spinner
      margin: 0 10px
  .cargando-spinner
    width: 86px
    div
      position: absolute
      width: 14px
      height 14px
      border-radius 50%
  .dotOne
    animation changeColor 1s infinite
    animation-delay 0.1s
    left 45%
    top 50%
  .dotTwo
    animation changeColor 1s infinite
    animation-delay 0.2s
    left 46%
    top 50%
  .dotThree
    animation changeColor 1s infinite
    animation-delay 0.3s
    left 47%
    top 50%
  .dotFour
    animation changeColor 1s infinite
    animation-delay 0.4s
    left 48%
    top 50%
  .dotFive
    animation changeColor 1s infinite
    animation-delay 0.5s
    left 49%
    top 50%
  .dotSix
    animation changeColor 1s infinite
    animation-delay 0.6s
    left 50%
    top 50%
  .dotSeven
    animation changeColor 1s infinite
    animation-delay 0.7s
    left 51%
    top 50%
  @keyframes changeColor
    from
      background-color #FFFFFF
    to
      background-color  #43ADE1
  #buttons
    background-color: #43ADE1
    border: none
    position: relative
    color: white
    border-radius: 6px
    padding: 12px 0
    height: 50px
    width: 90%
    margin: 0 auto
    display: block
    text-align: center
    font-size: 16px
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1)
    transition: background-color 0.3s, transform 0.2s
  #buttons:hover
    background-color: #2D9CD3
    transform: translateY(-2px)
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2)
    font-weight: bold
  #buttons:active
    transform: translateY(0)
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1)
  #tittle
    color: #43ADE1
</style>
